import { combineEpics } from 'redux-observable';

import { _reducer } from './progressGoals.reducers';
import _epics from './progressGoals.epics';

export const epics = combineEpics(_epics);
export { _reducer };
export * from './progressGoals.actions';
